import { StatusOption } from './types';

export const statusOptions: StatusOption[] = [
  { label: 'Estimate', property: 'showEstimate' },
  { label: 'Fulfilled', property: 'showFulfilled' },
  { label: 'Issued', property: 'showIssued' },
  { label: 'In Progress', property: 'showInProgress' },
  { label: 'Voided', property: 'showVoided' },
];
